const base = {
	serverUrl: process.env.NODE_ENV !== 'production' ? 'http://petra.css.wonderfull.cn/api' : '/api'
};

export default base;